import React from "react";
import auth from "../../services/authService";
import "./SideDrawer.css";
import { NavLink } from "react-router-dom";
import LinkButton from "../common/linkButton";

const SideDrawer = ({
  show,
  newBlankProposal,
  clearProposalState,
  user: suppliedUser,
  canAccessSupport = false,
}) => {
  let drawerClasses = "side-drawer";
  if (show) {
    drawerClasses = "side-drawer open";
  }

  const user = suppliedUser || auth.getCurrentUser();

  return (
    <nav className={drawerClasses}>
      <ul>
        <li>{user && <NavLink to="/proposals">Home</NavLink>}</li>
        <li>
          {user && (
            <LinkButton
              className="btn btn-primary"
              style={{ color: "white", padding: "10px 25px", fontSize: "20px", width: "100%" }}
              to="/plan/step-guide"
              title="Create Investment Strategy Plan and Fee Disclosure (ISP)"
              onClick={() => clearProposalState && clearProposalState()}
            >
              Create ISP
            </LinkButton>
          )}
        </li>
        <li>
          {user && (
            <LinkButton
              className="btn btn-success"
              style={{ color: "white", padding: "10px 25px", fontSize: "20px", width: "100%" }}
              to="/proposals/step-guide"
              onClick={() => newBlankProposal()}
            >
              Create Proposal
            </LinkButton>
          )}
        </li>
        <li>{user && <NavLink to="/submissions">Submissions</NavLink>}</li>
        <li>
          {user && canAccessSupport && (
            <NavLink to="/support">Support</NavLink>
          )}
        </li>
        <li>{user && <NavLink to="/user">Settings</NavLink>}</li>
        <li>
          {!user && <NavLink to="/login">Login</NavLink>}
          {user && <NavLink to="/logout">Logout</NavLink>}
        </li>
      </ul>
    </nav>
  );
};

export default SideDrawer;
